class CollectionGridCarla {
  constructor(section) {
    this.section = section;
    this.filtersPanel = section.querySelector('[data-collection-filters-panel]');
    this.sortSelect = section.querySelector('#SortBy');
    this.modal = section.querySelector('[data-qb-modal]');
    this.activeProduct = null;
    this.selectedOptions = [];
    this.lastFocus = null;
    const isEnglish = (document.documentElement.lang || '').split('-')[0] === 'en';
    this.labels = isEnglish
      ? { add: 'Add to cart', unavailable: 'Unavailable', error: 'Could not add the product to your cart' }
      : { add: 'Dodaj do koszyka', unavailable: 'Niedostępne', error: 'Nie udało się dodać produktu' };
    this.bindEvents();
    this.syncFacetButtons();
  }

  closeSortPanels(exceptPanel) {
    this.section.querySelectorAll('[data-collection-sort-panel]').forEach((panel) => {
      if (panel !== exceptPanel) panel.hidden = true;
    });
  }

  getSortPanel(trigger) {
    return trigger.closest('[data-collection-sort-wrap]')?.querySelector('[data-collection-sort-panel]');
  }

  bindEvents() {
    this.section.addEventListener('toggle', (event) => {
      if (event.target.matches('.cm-facet')) {
        event.target.querySelector('summary')?.setAttribute('aria-expanded', String(event.target.open));
      }
    }, true);
    document.addEventListener('click', (event) => {
      this.section.querySelectorAll('.cm-facet[open]').forEach((facet) => {
        if (!facet.contains(event.target)) facet.open = false;
      });
    });
    this.section.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const facet = event.target.closest('.cm-facet[open]');
      if (facet) {
        facet.open = false;
        facet.querySelector('summary').focus();
      }
    });
    this.section.addEventListener('click', (event) => {
      const toggleFilters = event.target.closest('[data-collection-toggle-filters]');
      if (toggleFilters) {
        event.preventDefault();
        this.togglePanel(this.filtersPanel);
        this.closeSortPanels();
        return;
      }
      const closeFilters = event.target.closest('[data-collection-close-filters]');
      if (closeFilters) {
        event.preventDefault();
        if (this.filtersPanel) this.filtersPanel.hidden = true;
        return;
      }
      const toggleSort = event.target.closest('[data-collection-toggle-sort]');
      if (toggleSort) {
        event.preventDefault();
        const sortPanel = this.getSortPanel(toggleSort);
        if (!sortPanel) return;
        const willOpen = sortPanel.hidden;
        this.closeSortPanels();
        if (this.filtersPanel) this.filtersPanel.hidden = true;
        sortPanel.hidden = !willOpen;
        return;
      }
      const sortOption = event.target.closest('[data-collection-sort-option]');
      if (sortOption && this.sortSelect) {
        event.preventDefault();
        this.sortSelect.value = sortOption.dataset.value;
        this.sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
        this.sortSelect.dispatchEvent(new Event('input', { bubbles: true }));
        this.closeSortPanels();
        this.updateSortLabel(sortOption.textContent.trim());
        this.section.querySelectorAll('[data-collection-sort-option]').forEach((option) => {
          option.classList.toggle('is-active', option.dataset.value === sortOption.dataset.value);
        });
        return;
      }
      const applyBtn = event.target.closest('[data-collection-filters-apply]');
      if (applyBtn) {
        event.preventDefault();
        const form = this.section.querySelector('#FacetFiltersForm');
        if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
        if (this.filtersPanel) this.filtersPanel.hidden = true;
        return;
      }
      const goProductBtn = event.target.closest('[data-collection-go-product]');
      if (goProductBtn) {
        event.preventDefault();
        event.stopPropagation();
        const card = goProductBtn.closest('.collection-grid-carla__card');
        if (card && card.href) window.location.href = card.href;
        return;
      }
      const variantsBtn = event.target.closest('[data-collection-quick-variants]');
      if (variantsBtn) {
        event.preventDefault();
        event.stopPropagation();
        this.openQuickBuyModal(variantsBtn);
        return;
      }
      const quickAddBtn = event.target.closest('[data-collection-quick-add]');
      if (quickAddBtn) {
        event.preventDefault();
        event.stopPropagation();
        this.addToCart(quickAddBtn.dataset.variantId, quickAddBtn);
        return;
      }
      if (event.target.closest('[data-qb-close]')) {
        event.preventDefault();
        this.closeQuickBuyModal();
        return;
      }
      const submitBtn = event.target.closest('[data-qb-submit]');
      if (submitBtn && this.modal && this.modal.contains(submitBtn)) {
        event.preventDefault();
        const variant = this.getSelectedVariant();
        if (!variant || !variant.available) return;
        this.addToCart(String(variant.id), submitBtn, { closeModal: true });
      }
    });
    this.section.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal && !this.modal.hidden) this.closeQuickBuyModal();
    });
    this.section.addEventListener('change', (event) => {
      const optionInput = event.target.closest('[data-qb-option-input]');
      if (optionInput && this.modal && this.modal.contains(optionInput)) {
        if (optionInput.disabled) return;
        const optionIndex = Number(optionInput.dataset.optionIndex);
        this.selectedOptions[optionIndex] = optionInput.value;
        this.renderOptionStates();
        this.updateModalVariantUI();
        return;
      }
      const checkbox = event.target.closest('#FacetFiltersForm input[type="checkbox"]');
      if (checkbox) this.syncFacetButton(checkbox);
    });
    const filterForm = this.section.querySelector('#FacetFiltersForm');
    if (filterForm) filterForm.addEventListener('input', () => {
      window.setTimeout(() => this.syncFacetButtons(), 900);
    });
  }

  parseProductJson(button) {
    const jsonEl = button.closest('.collection-grid-carla__item')?.querySelector('[data-quick-buy-json]');
    if (!jsonEl) return null;
    try { return JSON.parse(jsonEl.textContent); }
    catch (error) { console.error('Quick buy product JSON parse error', error); return null; }
  }

  openQuickBuyModal(button) {
    if (!this.modal) return;
    const product = this.parseProductJson(button);
    if (!product) return;
    this.activeProduct = product;
    this.lastFocus = button;
    this.selectedOptions = [];
    const variantId = new URL(product.url, window.location.origin).searchParams.get('variant');
    const filteredVariant = product.variants.find((variant) => String(variant.id) === variantId);
    product.options.forEach((option, index) => {
      if (filteredVariant) { this.selectedOptions[index] = filteredVariant[`option${index + 1}`]; return; }
      const match = product.variants.find((variant) => {
        if (!variant.available) return false;
        return this.selectedOptions.every((value, optIndex) => variant[`option${optIndex + 1}`] === value);
      });
      this.selectedOptions[index] = match ? match[`option${index + 1}`] : option.values[0] || null;
    });
    const titleEl = this.modal.querySelector('[data-qb-title]');
    const imageEl = this.modal.querySelector('[data-qb-image]');
    const submitLabel = this.modal.querySelector('[data-qb-submit-label]');
    const errorEl = this.modal.querySelector('[data-qb-error]');
    if (titleEl) titleEl.textContent = product.title;
    if (submitLabel) submitLabel.textContent = product.add_label || this.labels.add;
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    if (imageEl) {
      const src = product.featured_image || '';
      imageEl.src = src;
      imageEl.alt = product.title || '';
      imageEl.hidden = !src;
    }
    this.renderOptions();
    this.updateModalVariantUI();
    this.modal.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
    const closeBtn = this.modal.querySelector('.collection-grid-carla__qb-close');
    if (closeBtn) closeBtn.focus();
  }

  closeQuickBuyModal() {
    if (!this.modal || this.modal.hidden) return;
    this.modal.hidden = true;
    document.documentElement.classList.remove('overflow-hidden');
    this.activeProduct = null;
    this.selectedOptions = [];
    const submitBtn = this.modal.querySelector('[data-qb-submit]');
    if (submitBtn) this.setLoading(submitBtn, false);
    if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    this.lastFocus = null;
  }

  renderOptions() {
    const optionsEl = this.modal?.querySelector('[data-qb-options]');
    if (!optionsEl || !this.activeProduct) return;
    optionsEl.innerHTML = this.activeProduct.options.map((option, optionIndex) => {
      const values = option.values.map((value, valueIndex) => {
        const available = this.isOptionValueAvailable(optionIndex, value);
        const selected = this.selectedOptions[optionIndex] === value;
        const inputId = `qb-${this.activeProduct.id}-${optionIndex}-${valueIndex}`;
        const inputName = `qb-option-${this.activeProduct.id}-${optionIndex}`;
        return `<div class="product-variant-carla__cell">
          <input type="radio" id="${inputId}" name="${inputName}" value="${this.escapeHtml(value)}"
            class="product-variant-carla__input${available ? '' : ' disabled'}" data-qb-option-input
            data-option-index="${optionIndex}" ${selected ? 'checked' : ''} ${available ? '' : 'disabled'}>
          <label for="${inputId}" class="product-variant-carla__option${available ? '' : ' product-variant-carla__option--unavailable'}">
            <span class="product-variant-carla__value">${this.escapeHtml(value)}</span>
            ${available ? '' : '<span class="product-variant-carla__strike" aria-hidden="true"></span>'}
          </label></div>`;
      }).join('');
      return `<div class="product-variant-carla">
        <div class="product-variant-carla__header"><span class="product-variant-carla__label">${this.escapeHtml(option.name)}</span></div>
        <div class="product-form__input product-form__input--carla-grid" role="radiogroup" aria-label="${this.escapeHtml(option.name)}">${values}</div>
      </div>`;
    }).join('');
  }

  renderOptionStates() {
    if (!this.modal || !this.activeProduct) return;
    this.activeProduct.options.forEach((option, optionIndex) => {
      const current = this.selectedOptions[optionIndex];
      if (current && !this.isOptionValueAvailable(optionIndex, current)) {
        const fallback = option.values.find((value) => this.isOptionValueAvailable(optionIndex, value));
        this.selectedOptions[optionIndex] = fallback || option.values[0] || null;
      }
    });
    this.modal.querySelectorAll('[data-qb-option-input]').forEach((input) => {
      const optionIndex = Number(input.dataset.optionIndex);
      const value = input.value;
      const available = this.isOptionValueAvailable(optionIndex, value);
      const selected = this.selectedOptions[optionIndex] === value;
      const label = input.nextElementSibling;
      input.checked = selected;
      input.disabled = !available;
      input.classList.toggle('disabled', !available);
      if (label) {
        label.classList.toggle('product-variant-carla__option--unavailable', !available);
        let strike = label.querySelector('.product-variant-carla__strike');
        if (!available && !strike) {
          strike = document.createElement('span');
          strike.className = 'product-variant-carla__strike';
          strike.setAttribute('aria-hidden', 'true');
          label.appendChild(strike);
        } else if (available && strike) strike.remove();
      }
    });
  }

  isOptionValueAvailable(optionIndex, value) {
    if (!this.activeProduct) return false;
    return this.activeProduct.variants.some((variant) => {
      if (!variant.available) return false;
      if (variant[`option${optionIndex + 1}`] !== value) return false;
      return this.selectedOptions.every((selectedValue, index) => {
        if (index === optionIndex || !selectedValue) return true;
        return variant[`option${index + 1}`] === selectedValue;
      });
    });
  }

  getSelectedVariant() {
    if (!this.activeProduct) return null;
    return this.activeProduct.variants.find((variant) =>
      this.activeProduct.options.every((_, index) => variant[`option${index + 1}`] === this.selectedOptions[index])
    ) || null;
  }

  updateModalVariantUI() {
    if (!this.modal || !this.activeProduct) return;
    const variant = this.getSelectedVariant();
    const priceEl = this.modal.querySelector('[data-qb-price]');
    const imageEl = this.modal.querySelector('[data-qb-image]');
    const submitBtn = this.modal.querySelector('[data-qb-submit]');
    const submitLabel = this.modal.querySelector('[data-qb-submit-label]');
    const errorEl = this.modal.querySelector('[data-qb-error]');
    if (priceEl) priceEl.textContent = variant?.price || this.activeProduct.variants[0]?.price || '';
    if (imageEl) {
      const src = variant?.featured_image || this.activeProduct.featured_image || '';
      if (src) { imageEl.src = src; imageEl.hidden = false; }
    }
    const canAdd = Boolean(variant && variant.available);
    if (submitBtn) { submitBtn.disabled = !canAdd; submitBtn.classList.toggle('is-disabled', !canAdd); }
    if (submitLabel && this.activeProduct.add_label) {
      submitLabel.textContent = canAdd ? this.activeProduct.add_label : variant ? this.labels.unavailable : this.activeProduct.add_label;
    }
    if (errorEl && canAdd) { errorEl.hidden = true; errorEl.textContent = ''; }
  }

  setLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('is-loading', isLoading);
    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  addToCart(variantId, triggerBtn, options = {}) {
    if (!variantId || (triggerBtn && triggerBtn.classList.contains('is-loading'))) return;
    const cart = document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(triggerBtn);
    }
    config.body = formData;
    this.setLoading(triggerBtn, true);
    const errorEl = this.modal?.querySelector('[data-qb-error]');
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description || response.message);
          if (errorEl) { errorEl.hidden = false; errorEl.textContent = response.description || response.message || this.labels.error; }
          return;
        }
        if (!cart) { window.location.href = window.routes.cart_url; return; }
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'collection-grid-carla', productVariantId: variantId, cartData: response });
        }
        cart.classList.remove('is-empty');
        cart.renderContents(response);
        if (options.closeModal) this.closeQuickBuyModal();
      })
      .catch((error) => {
        console.error(error);
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = this.labels.error; }
      })
      .finally(() => {
        if (triggerBtn && document.body.contains(triggerBtn)) {
          const shouldStayDisabled = options.closeModal && triggerBtn.hasAttribute('data-qb-submit');
          if (!shouldStayDisabled) {
            this.setLoading(triggerBtn, false);
            if (triggerBtn.hasAttribute('data-qb-submit')) this.updateModalVariantUI();
          }
        }
      });
  }

  escapeHtml(value) {
    return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  togglePanel(panel) { if (panel) panel.hidden = !panel.hidden; }
  syncFacetButtons() {
    this.section.querySelectorAll('#FacetFiltersForm input[type="checkbox"]').forEach((input) => this.syncFacetButton(input));
  }
  syncFacetButton(input) {
    const label = input.closest('.collection-grid-carla__size-btn, .collection-grid-carla__chip-btn, .collection-grid-carla__swatch');
    if (label) label.classList.toggle('is-active', input.checked);
  }
  updateSortLabel(text) {
    this.section.querySelectorAll('[data-collection-sort-label]').forEach((el) => { el.textContent = text; });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection-grid-carla').forEach((section) => { new CollectionGridCarla(section); });
});
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.collection-grid-carla');
  if (section) new CollectionGridCarla(section);
});
